import Styled from 'styled-components';

const Wrapper = Styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = Styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: #666666;
  margin: 0 0 10px 15px;
`;

export { Wrapper, Text };
